<div class="bg-image"></div>

<div class="w-100 h-100 d-flex" style="z-index: 100">
	<div class="d-flex w-100 h-100 justify-content-center" *ngIf="isLoading">
		<mat-spinner style="margin: auto;" [diameter]="50"></mat-spinner>
	</div>
	<div class="purchase-product-container" *ngIf="!isLoading">
		<ng-container [ngSwitch]="step">

			<ng-container *ngSwitchCase="1">
				<app-purchase-new-app
					[isSingleAppPurchase]="true"
					[hideCadSoftwareSelection]="productTypeFromQuery !== productTypeEnum.Sketch"
					[(subscriptionState)]="subscriptionState"
					[(selectedBillingCycle)]="selectedBillingCycle"
					[selectedCurrency]="selectedCountryCurrency"
					(goForward)="calculateSummaryGoGorward()">
				</app-purchase-new-app>
				<!-- <app-plan-selector 
					[subscriptionState]="subscriptionState"
					[subscriptionBillingCycle]="selectedBillingCycle"
					[selectedCountryCurrency]="selectedCountryCurrency"
					[billingCycleVisible]="true"
					[backButtonEnabled]="planSelectorBackButtonEnabled"
					[mode]="'purchase-new-plan'"
					(subscriptionStateChanged)="subscriptionStateChanged($event)"
					(saveTriggered)="step=3"
					(onBillingCycleChanged)="onBillingCycleChanged($event)"
					(backTriggered)="step=2">
				</app-plan-selector> -->
			</ng-container>

			<!-- <ng-container *ngSwitchCase="2">
				<app-sketch-variant-selector 
					[availableSketchApps]="availableSketchApps"
					[selectedSoftware]="subscriptionState.selectedApp" 
					(next)="onSketchVariantSelection($event)">
				</app-sketch-variant-selector>
			</ng-container> -->

			<ng-container *ngSwitchCase="2">
				<div class="d-flex flex-column overflow-auto order-summary-page p-sm-4">
					<div class="d-flex gap-2 flex-column-reverse flex-sm-row h-100">
						<div class="p-4 bg-whitesmoke rounded col-12">
							<h3 class="mb-4 text-center fw-bold">Checkout</h3>
							<div *ngFor="let plan of selectedPlans" class="mb-4">
								<div class="d-flex flex-column">
									<div class="d-flex mb-2 justify-content-between">
										<div>
											<h5 class="mb-1 fwbold appName" title="Selected Product">
												{{ appNames[plan.productType] }}
											</h5>
											<span class="text-muted mb-0">
													{{ plan.name }}
													{{
													plan.unlimitedUsers
													? " - Unlimited Users"
													: " - For " + plan.numberOfUsers + (plan.numberOfUsers === 1 ? " user" : " users")
													}}
											</span>
										</div>
										<h5 class="mb-0">
											{{ plan.rate | number:'1.0-0'  }} {{ selectedCountryCurrency }}/{{
											selectedBillingCycle === "Monthly" ? "mo" : "yr"
											}}
										</h5>
									</div>
									<app-selected-app-description 
										[selectedApp]="plan.productType"
										[showBulletPoints]="false"
										[showDescription]="false">
									</app-selected-app-description> 
								</div>
							</div>
							<div class="border-top pt-3 mt-3">
								<div class="d-flex justify-content-between">
									<h4 class="fw-bold">Net Total</h4>
									<h4 class="fw-bold" style="color: #004300;">
										{{ totalCost | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
										selectedBillingCycle === "Monthly" ? "mo" : "yr"
										}}
									</h4>
								</div>
							</div>
						</div>
					</div>
					<app-payment-info class="mt-3" [(selected)]="isPaymentSelected" [trialDays]="selectedPlans[0].numberOfTrialDays"></app-payment-info>
					<div class="mt-4 text-center d-flex justify-content-between align-items-center" *ngIf="productPurchaseStatus === null">
						<dx-button text="Back" icon="arrowleft" type="normal"
							(onClick)="goToPreviousStep()"></dx-button>
						<button [disabled]="!isPaymentSelected" class="complete-button px-2 px-sm-5" (click)="purchaseProduct()">
							Purchase Product
						</button>
					</div>
					<div class="registration-status mt-3">
						<div class="d-flex h-100 justify-content-center align-items-center gap-3"
							*ngIf="productPurchaseStatus === 'awaiting'">
							<h4 class="fw-bold m-0 text-center">Purchase in Progress</h4>
							<mat-spinner class="mat-spinner"></mat-spinner>
							<!-- <h4 class="fw-bold text-center">Please Wait</h4> -->
						</div>
						<div class="d-flex h-100 justify-content-center align-items-center gap-1"
							*ngIf="productPurchaseStatus === 'success'">
							<span class="material-icons" style="color: #1da24f; font-size: 40px; height: 40px">
								check_circle
							</span>
							<h4 class="fw-bold text-center m-0">Purchase Successful</h4>
							<!-- <h6 class="text-center"> Go Home To Start Using The App</h6> -->
							<dx-button text="Go Home" stylingMode="contained" [style.backgroundColor]="'#0fa2d9'"
								[style.color]="'#ffffff'" class="ms-auto" (onClick)="goToHomePage()"></dx-button>
						</div>
						<div class="d-flex h-100 justify-content-center align-items-center gap-3"
							*ngIf="productPurchaseStatus === 'failure'">
							<span class="material-icons" style="color: #d01301; font-size: 40px; height: 40px">
								cancel
							</span>
							<h4 class="fw-bold text-center m-0">Purchase Failed, Please try again later.</h4>
							<!-- <h6 class="text-center m-0">
								Some error occured. Please try again later.
							</h6> -->
							<dx-button text="Close" stylingMode="contained" type="danger" class="ms-auto"
								(onClick)="goToHomePage()"></dx-button>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</div>
</div>